/**
 * Connects external sidebar arrows to the slideshow component
 */
class ResourceListSidebarArrows extends HTMLElement {
  connectedCallback() {
    this.arrows = this.querySelectorAll('button');
    if (!this.arrows || this.arrows.length === 0) return;
    
    // Find the associated slideshow using the ref attribute
    const slideshowRef = this.getAttribute('slideshow-ref');
    if (!slideshowRef) return;
    
    // Find the slideshow component with matching ref
    this.slideshow = document.querySelector(`slideshow-component[ref="${slideshowRef}"]`);
    if (!this.slideshow) return;
    
    // Add click handlers to the arrows
    this.arrows.forEach(arrow => {
      const action = arrow.getAttribute('ref');
      if (action === 'previous') {
        arrow.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.slideshow && typeof this.slideshow.previous === 'function') {
            this.slideshow.previous(e);
          }
        });
      } else if (action === 'next') {
        arrow.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.slideshow && typeof this.slideshow.next === 'function') {
            this.slideshow.next(e);
          }
        });
      }
    });
    
    // Update arrow disabled states
    this.updateArrowStates();
    
    // Listen for slideshow changes to update arrow states
    this.slideshow.addEventListener('slideshow:select', () => {
      this.updateArrowStates();
    });
  }
  
  updateArrowStates() {
    if (!this.slideshow || !this.arrows) return;
    
    const arrowsArray = Array.from(this.arrows);
    const previousArrow = arrowsArray.find(arrow => arrow.getAttribute('ref') === 'previous');
    const nextArrow = arrowsArray.find(arrow => arrow.getAttribute('ref') === 'next');
    
    const isInfinite = this.slideshow.infinite !== undefined ? this.slideshow.infinite : false;
    const isAtStart = this.slideshow.atStart !== undefined ? this.slideshow.atStart : false;
    const isAtEnd = this.slideshow.atEnd !== undefined ? this.slideshow.atEnd : false;
    
    if (previousArrow) {
      previousArrow.disabled = !isInfinite && isAtStart;
    }
    
    if (nextArrow) {
      nextArrow.disabled = !isInfinite && isAtEnd;
    }
  }
}

if (!customElements.get('resource-list-sidebar-arrows')) {
  customElements.define('resource-list-sidebar-arrows', ResourceListSidebarArrows);
}
